import { Route } from "react-router-dom";
import { Switch } from "react-router-dom";

import routes from "routes";
import { ResultsUni5TreatmentOptions } from "./ResultsUni5TreatmentOptions";
import { ResultsUni5ClinicalPlans } from "./ResultsUni5ClinicalPlans";
import { ResultsUni5Pricing } from "./ResultsUni5Pricing";
import { ResultsUni5 } from ".";

export const ResultsUni5Router: React.FC = () => {
  return (
    <Switch>
      <Route path={routes.treatmentOptions}>
        <ResultsUni5TreatmentOptions />
      </Route>
      <Route path={routes.plans}>
        <ResultsUni5ClinicalPlans />
      </Route>
      <Route path={routes.pricing}>
        <ResultsUni5Pricing />
      </Route>
      <ResultsUni5 />
    </Switch>
  );
};
